<template>
  <div class="footer-menu">
    <div class="footer-info-area footer-info-link-all">
      <ul>
        <li>
          <a href="/customer/company.html" target="_blank">회사소개</a>
        </li>
        <li>
          <a href="/customer/recruit.html" target="_blank">인재채용</a>
        </li>
        <li>
          <a @click.prevent="moveUrl('service')" href="#" :class="isService ? 'on' : ''">서비스 소개</a>
        </li>
        <li>
          <a @click.prevent="moveUrl('agreement')" href="#">이용약관</a>
        </li>
        <li class="footer-privacy">
          <!-- query, text -->
          <a v-if="isWavveOn" @click.prevent="moveUrl('agreement', 'pooqzone_privacy')" href="#">웨이브온 개인정보 처리방침</a>
          <a v-else @click.prevent="moveUrl('agreement', 'privacy')" href="#">개인정보 처리방침</a>
        </li>
        <li><a @click.prevent="moveUrl('notice_list')" href="#">고객센터</a></li>
      </ul>
    </div>
    <div class="footer-info-area footer-info-copyright">
      <span>콘텐츠웨이브 주식회사</span>
      <span>대표이사 이태현</span>
      <span class="last">고객센터 1599-3709 (평일 09:00~18:00 / 점심시간 12:00~13:00 / 주말 및 공휴일 휴무)</span>
      <br />
      <span>사업자등록번호 220-88-38020</span>
      <span class="last">호스팅서비스제공자 : 마이크로소프트 유한회사</span>
      <br />
      <span>통신판매업 신고번호 : 제 2021-서울영등포-0585호</span>
      <span class="last">통신판매업 정보 공개 : <a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=220-88-38020" class="info-link" target="_blank">http://www.ftc.go.kr/bizCommPop.do?wrkr_no=220-88-38020</a></span>
      <br />
      <address>서울특별시 영등포구 여의나루로 60 포스트타워 19층</address>
      <span class="last">전자우편주소 : <a href="mailto:helpdesk@wavve.com" >helpdesk@wavve.com</a></span>
      <span class="copyright">Copyright© 콘텐츠웨이브(주) All rights reserved.</span>
    </div>
    <div class="footer-wavveon">
      <div class="wavveon-footer-logo">
        <label for="wavveon-logo">
          <img src="../../../assets/images/common/ico-footer-pooqzone.png" alt="wavve on" />
        </label>
      </div>

      <select id="wavveon-logo" onchange="if(this.value) location.href=(this.value);">
        <option value="" disabled selected hidden>사업자용 웨이브 가입</option>
        <option value="http://www.pooqzone.co.kr/Index.aspx">웨이브온 서비스 소개</option>
        <option value="http://www.pooqzone.co.kr/join_pcbang.aspx">웨이브온 PC방 서비스</option>
        <option value="http://www.pooqzone.co.kr/join_library.aspx">웨이브온 도서관 서비스</option>
        <option value="http://www.pooqzone.co.kr/join_hospital.aspx">웨이브온 병원 서비스</option>
        <option value="http://www.pooqzone.co.kr/join_movienet.aspx">웨이브온 숙박 서비스</option>
        <option value="http://www.pooqzone.co.kr/join_others.aspx">웨이브온 일반 서비스</option>
      </select>

      <div class="footer-sns">
        <a href="https://www.facebook.com/wavve.official/" target="_blank">
          <img src="../../../assets/images/common/ico-footer-sns.png" alt="wavve 페이스북" />
        </a>
        <a href="http://m.post.naver.com/my.nhn?memberNo=12375258" target="_blank">
          <img src="../../../assets/images/common/ico-footer-post.png" alt="wavve 네이버 포스트" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
export default {
  props: {
    isService: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isWavveOn: cookie.isWavveOn()
    }
  },
  methods: {
    moveUrl (routeName, category = '') {
      scrollTop() // 스크롤을 제일 위로
      if (category !== '') {
        this.$router.push({
          name: routeName,
          query: {
            category: category
          }
        })
      } else {
        this.$router.push({ name: routeName })
      }
    }
  }
}
</script>
